import { render, staticRenderFns } from "./CantFind.vue?vue&type=template&id=10c761a5&scoped=true&"
import script from "./CantFind.vue?vue&type=script&lang=js&"
export * from "./CantFind.vue?vue&type=script&lang=js&"
import style0 from "./CantFind.vue?vue&type=style&index=0&id=10c761a5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c761a5",
  null
  
)

export default component.exports